

<div class="{{'docs-DialogExample-lgHeader '+modalNotifyType.Class+''}}"  >
  <div class="ms-Dialog ms-Dialog--lgHeader ms-Dialog-Notify" >
    <div class="ms-Dialog-title">{{titulo}}</div>
    <div class="ms-Dialog-content">
      <div class="ms-Grid" dir="ltr">
        <div class="ms-Grid-row">
          <div class="ms-Grid-col ms-sm2 ms-lg2">
            <span><i [class]="modalNotifyType.Icon"></i></span>
          </div>
          <div class="ms-Grid-col ms-sm10 ms-lg10">
            <p class="ms-Dialog-subText ms-Dialog-subText-notify modal__notify-text" [innerHTML]="internalDescription"></p>
          </div>
        </div>
      </div>
      <div class="ms-Dialog-actions">
        <button *ngIf="!isDelete" class="ms-Button ms-Dialog-action ms-Button--primary" type="button" [hidden]="!viewOk" (click)="close()">
          <span class="ms-Button-label">{{ok}}</span> 
        </button>
        <button *ngIf="isDelete" class="ms-Button ms-Dialog-action ms-Button--primary" type="button" [hidden]="!viewOk" (click)="close()">
          <span class="ms-Button-label">Regresar</span> 
        </button>
        <button *ngIf="isDelete" class="ms-Button ms-Dialog-action ms-Button--primary" type="button" [hidden]="!viewOk" (click)="confirmAction(true)" >
          <span class="ms-Button-label">Confirmar</span> 
        </button>
        
      </div>
    </div>
    
  </div>
</div>
